/**
 * @description i18n en
 * @author wangfupeng
 */

export default {
  tableModule: {
    modal: {
      border: 'Border',
      borderWidth: 'Width',
      bgColor: 'Back color',
      align: 'Text Align',
      ok: 'OK',
    },
    color: {
      default: 'Default color',
      clear: 'Clear back color',
    },
    borderStyle: {
      none: 'None',
      solid: 'Solid',
      dotted: 'Dotted',
      dashed: 'Dashed',
      double: 'Double',
      groove: 'Groove',
      ridge: 'Ridge',
      inset: 'Inset',
      outset: 'Outset',
    },
    deleteCol: 'Delete column',
    deleteRow: 'Delete row',
    deleteTable: 'Delete table',
    widthAuto: 'Fit width',
    insertCol: 'Insert column',
    insertRow: 'Insert row',
    insertTable: 'Insert table',
    header: 'Header',
    mergeCell: 'merge cell',
    splitCell: 'split cell',
    tableProperty: 'Table property',
    cellProperty: 'Cell property',
  },
}
